import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@independent-software/typeui/controls/Button';
import { Icon } from '@independent-software/typeui/controls/Icon';

import { AuthContext } from '../../AuthContext';
import { FilterContext } from '../../FilterContext';
import { Container, Content, BottomBar } from '../../modules';
import { Result } from '../../resource/';
import { ListResults } from './ListResults';
import { Gate } from '../../controls/Gate';

const ResultList = () => {
  const auth = React.useContext(AuthContext);
  const filter = React.useContext(FilterContext);
  const navigate = useNavigate();

  // Go to add result view.
  const handleAdd = () => {
    navigate('/results/add');
  }  

  // Go to view result view.
  const handleClick = (item: Result) => {
    navigate(`/results/${item.id}`);
  }  

  return (
    <Container>
      <Content>
        <ListResults auth={auth} filter={filter} name="results" onClick={handleClick}/>
      </Content>
      <BottomBar>
        <Gate right='can_edit_results'>
          <Button primary onClick={handleAdd}><Icon name="plus"/> Add result</Button>
        </Gate>
      </BottomBar>
    </Container>
  );
}

export { ResultList }
